import { SurveyResponseType } from 'shared/types';

export type NoteType = {
  action: string | null;
  created_at: string;
  created_by: string;
  deleted: boolean;
  display_id: string;
  notes: string;
  response_id: string;
  survey_id: string;
  updated_at: string;
};

export interface BulkActionsResponse {
  response_bulk_action_type: ResponseBulkActionType;
  survey_id: string;
  response_ids: string[];
  // 'any' in "values" can be string or string[]
  values: Record<string, any>;
}

export enum ResponseBulkActionType {
  TRIGGER_WORKFLOW = 'TRIGGER_WORKFLOW',
  MARK_AS_FAVOURITE = 'MARK_AS_FAVOURITE',
  ADD_TAGS = 'ADD_TAGS',
  MARK_INVALID = 'MARK_INVALID',
  MARK_AS_NONACTIONABLE = 'MARK_AS_NONACTIONABLE',
  DELETE_RESPONSE = 'DELETE_RESPONSE',
}

export type SentimentType = Lowercase<
  Exclude<
    SurveyResponseType['freddy_response_analysis'],
    null | undefined
  >['customer_sentiment']
>;
